<template>
  <!-- <div class="pack-box" :class="`pack-box${copyright.entrantsType}`">123</div> -->
  <div class="examPackPartner">
    <div class="partenr_top">
      <div class="top_center">
        <!-- 面包屑 -->
        <div class="crumbs">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>试题题库</el-breadcrumb-item>
            <el-breadcrumb-item>{{ detail.name }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="name">{{ detail.name }}</div>
        <div class="tip">
          本试题知识点分布合理，涵盖了记忆、理解、应用、分析、评价、创造六个维度
        </div>
      </div>
      <div class="top_tip">
        <div class="tip_left">
          <div class="tip_name twoEllipsis">
            <span class="name">题库描述</span>
            <span class="tip">{{ detail.introduction }}</span>
          </div>
          <div class="tip_tip">
            <span class="one">时长</span>
            <span class="two">{{ detail.examTime }}分钟</span>
            <span class="three">·</span>
            <span class="one">学习人数</span>
            <span class="two">{{ detail.clicks }}</span>
            <span class="three">·</span>
            <span class="one">试卷数量</span>
            <span class="two">{{ detail.SubjectNum }}套</span>
          </div>
        </div>
        <div v-if="university != 1" class="tip_right">
          <div class="right_price">
            ￥<span class="price" v-if="detail.entrantsPrice || detail.entrantsPrice == 0">{{
              detail.entrantsPrice.toFixed(2) }}</span>
          </div>
          <div v-if="!$store.state.hidePurchaseButtons || detail.status == 1" class="right_btn" @click="goOrder()">{{ detail.status == 1 ? "已购买" : "立即购买" }}</div>
        </div>
      </div>
    </div>
    <div class="partenr_bottom">
      <div class="back">
        试卷列表
        <div class="line"></div>
      </div>
      <div class="dis_flex_between">
        <div v-if="list && list.length > 0" class="list">
          <div v-for="(item, index) in list" :key="index" class="item" @click="tabId = item.id">
            <img class="item-image" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/partner/papers1.png" />
            <div class="item-content">
              <div class="item-title ellipsis">{{ item.name }}</div>
              <div class="item-count">共{{ item.subjectNum }}道题</div>
              <!-- <div class="item-tips"> -->
              <!-- {{ detail.status == 1 ? "已购买" : "￥" + item.paperPrice }} -->
              <!-- {{ detail.status == 1 ? "已购买" : "" }} -->
              <!-- </div> -->
            </div>

            <el-button v-if="detail.status == 1 ||
              !item.packagePrice ||
              item.packagePrice == 0
            " :loading="item.loading" class="btn" @click="goLearn(item)">
              开始答题
            </el-button>
            <div v-else class="keep-learn keep-ok">开始答题</div>
          </div>
        </div>
        <class-push :search="search" class="youlove">其他课程推荐</class-push>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { getDomain, getInfo, getToken } from "@/api/cookies";
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
import classPush from "@/components/Know/classPushPartner.vue";
export default {
  components: { classPush },
  data() {
    return {
      packId: "",
      classId: null,
      detail: {}, // 试卷包详情
      list: [],
      userInfo: null,
      IsPurchase: false,
      classDetail: {},
      search: {
        kind: null,
      },
      Loading: false,
      university: '',
      copyright: {} /* { name: "同行转型", key: 1 },
    { name: "招商加盟", key: 2 },
    { name: "高校合伙人", key: 3 } */,
    };
  },
  async created() {
    this.copyright = getDomain();
    if (this.copyright.eId == process.env.VUE_APP_university) {
      this.university = 1
    }
    this.packId = this.$route.query.packId
      ? String(this.$route.query.packId)
      : null;
    this.classId = this.$route.query.classId
      ? String(this.$route.query.classId)
      : null;
    this.IsPurchase = this.$route.query.IsPurchase === true || this.$route.query.IsPurchase === "true";
    this.userInfo = getInfo();
    if (this.classId) {
      await homeClient.getCoachInfo(this.classId).then((res) => {
        if (res.code == 0) {
          this.classDetail = res.data || {};
        }
      });
    }
    await this.getDetail();
  },
  methods: {
    // 获取试卷包列表
    async getDetail() {
      // 与标准试卷包页使用相同接口，独立读取详情、试卷和购买状态。
      const [detailResponse, listResponse, purchaseResponse] = await Promise.all([
        homeClient.getDetails(this.packId),
        homeClient.getPaperListByPackageId({ packageId: this.packId }),
        homeClient.whetherBuy({ commodityId: this.packId, commodityTypeCode: 3 }),
      ]);
      const data = detailResponse.code == 0 ? detailResponse.data || {} : {};
      const rows = listResponse.code == 0 && listResponse.data && Array.isArray(listResponse.data.rows)
        ? listResponse.data.rows : [];
      // 保留班型入口传入的购买状态，再合并接口返回的购买结果。
      this.IsPurchase = this.IsPurchase || (purchaseResponse.code == 0 && purchaseResponse.data == 1);
      this.list = rows.map((item) => ({
        ...item,
        name: item.name || item.paperName || item.title,
        subjectNum: item.subjectNum != null ? item.subjectNum : item.topicNum,
        packagePrice: item.packagePrice != null ? item.packagePrice : item.price,
        loading: false,
      }));
      // 仅适配原模板字段，保留原详情展示、推荐项目及零元价格。
      const price = data.price != null ? data.price : (data.entrantsPrice != null ? data.entrantsPrice : data.originalPrice);
      this.detail = {
        ...data,
        name: data.name || data.title,
        clicks: data.clicks != null ? data.clicks : (data.viewCount || 0),
        entrantsPrice: Number(price || 0),
        SubjectNum: data.paperNum != null ? data.paperNum : this.list.length,
        status: this.IsPurchase ? 1 : 2,
      };
      this.search.kind = data.belongProject != null ? data.belongProject : data.kindId;
    },

    /* 做题 */
    async goLearn(item) {
      if (!this.userInfo) {
        Vue.prototype.goLoginView(false);
        return;
      }
      item.loading = true;
      try {
        const res = await homeClient.getNewPaperTopicById({ id: item.id });
        if (res.code == 0) {
          const data = res.data || {};
          const seeNum = data.seeNum != null ? data.seeNum : (data.trySee != null ? data.trySee : item.seeNum);
          // 标准跳转方法没有试看拦截，在本页保留原合作方入口的限制。
          if (!this.IsPurchase && !seeNum) {
            this.$notify({ title: "错误", message: "未购买，无法答题, 请先去购买", type: "error", duration: 2000 });
            return;
          }
          // 参数与 examDetails.vue 保持一致，继续携带试卷包和班型上下文。
          Vue.prototype.goExam({
            contactId: item.id,
            examType: 12,
            classesId: this.classId || undefined,
            title: item.name,
            type: 6,
            IsPurchase: this.IsPurchase,
            seeNum,
            courseId: this.packId,
          });
        }
      } finally {
        item.loading = false;
      }
    },
    // 立即购买
    async goOrder() {
      if (this.detail.status == 1) {
        return
      }
      if (getToken()) {
        // 班型仍购买班型商品；独立试卷包使用参照页的商品类型 3。
        const res = await homeClient.addPayOrders([{
          commodityTypeCode: this.classId ? 0 : 3,
          commodityId: this.classId || this.packId,
          discount: this.classId ? Number(this.classDetail.discountStatus == 1) : 0,
        }], undefined);
        if (res.code == 0) {
          this.$router.push({
            name: "个人中心订单页",
            params: { orderNumber: res.data.orderNum },
          });
        } else {
          this.$message.error(res.msg);
        }
      } else {
        Vue.prototype.goLoginView(true);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.examPackPartner {
  width: 100%;

  .partenr_top {
    width: 100%;
    height: 251px;
    background: url("https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/partner/paperbac.png") no-repeat;
    background-size: 100%;

    .top_center {
      width: 1200px;
      height: 140px;
      margin: 0 auto;

      .crumbs {
        padding-top: 19px;

        /deep/ .el-breadcrumb__item {
          .el-breadcrumb__inner,
          .el-breadcrumb__separator {
            color: #fff;
            font-size: 12px;
            margin: 0;
          }
        }
      }

      .name {
        font-size: 30px;
        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        padding: 40px 0 16px;
        text-align: center;
      }

      .tip {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
      }
    }

    .top_tip {
      width: 1200px;
      // height: 120px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
      margin: 43px auto 0;
      padding: 22px 40px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .tip_left {
        width: 624px;

        .tip_name {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666;
          line-height: 26px;

          .name {
            margin-right: 5px;
          }

          .tip {
            color: #999;
          }
        }

        .tip_tip {
          margin-top: 10px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;

          .one {
            color: #666;
            margin-right: 10px;
          }

          .three {
            margin: 0 10px;
          }
        }
      }

      .tip_right {
        display: flex;
        align-items: center;
        // margin-top: 12px;

        .right_price {
          font-size: 16px;
          font-family: Source Han Sans CN-Bold, Source Han Sans CN;
          color: #f9431e;
          margin-right: 40px;

          .price {
            font-weight: 700;
            font-size: 24px;
          }
        }

        .right_btn {
          width: 172px;
          height: 56px;
          background: linear-gradient(88deg, #ff6d1e 0%, #fe420e 100%);
          border-radius: 28px 28px 28px 28px;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          cursor: pointer;
        }
      }
    }
  }

  .partenr_bottom {
    width: 1200px;
    padding-top: 55px;
    margin: 0 auto;

    .back {
      position: relative;
      width: 56px;
      height: 14px;
      font-size: 14px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 14px;
      margin: 20px 0px 24px;
      cursor: pointer;

      .line {
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 20px;
        height: 4px;
        background: #1e82f5;
        border-radius: 2px 2px 2px 2px;
        opacity: 1;
      }
    }

    .list {
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      opacity: 1;
      width: 852px;
      padding: 20px;
    }

    .item {
      position: relative;
      width: 812px;
      height: 70px;
      background: #f9f9f9;
      border-radius: 6px 6px 6px 6px;
      margin-bottom: 10px;
      opacity: 1;
      display: flex;
      align-items: center;
      padding: 0 20px;

      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 108px;
        height: 36px;
        border-radius: 25px 25px 25px 25px;
        opacity: 1;
        border: 1px solid #b9bfc4;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #777a82;

        /deep/ .el-button {
          background: transparent;
        }
      }

      .btn:hover {
        border: 1px solid #2586f5;
        color: #2586f5;
        background-color: transparent;
      }

      .item-image {
        width: 33.3px;
        height: 36.5px;
        flex-shrink: 0;
        background: #f7f8f9;
        margin-right: 12px;
      }

      .item-content {
        height: 37px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-direction: column;

        .item-title {
          height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 14px;
          max-width: 650px;
        }

        .item-count {
          margin-top: 9px;
          height: 14px;
          line-height: 14px;
          font-size: 10px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }

      .keep-learn {
        flex-shrink: 0;
      }
    }
  }
}

/deep/ .el-button {
  background: transparent !important;
}
</style>
